export { default as locationDetails } from "./location-details";
export { default as locationIndex } from "./location-index";



// WEBPACK FOOTER //
// ./ducks/index.js